import { render, staticRenderFns } from "./ProcessMenuMobile.vue?vue&type=template&id=1131b3b0&scoped=true&"
import script from "./ProcessMenuMobile.vue?vue&type=script&lang=js&"
export * from "./ProcessMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131b3b0",
  null
  
)

export default component.exports